import constants from '#packages/constants';

import type { EditorAPI } from '#packages/editorAPI';

export const closeAddPagePanel = (editorAPI: EditorAPI) =>
  editorAPI.panelManager.closePanelByName(
    constants.PANEL_NAMES.ADD_PAGES_PANEL,
  );
